import Layout from '@/components/Layout'
export default [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '中国现代汉方数字化研究院',
    },
    component: Layout,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页',
          icon: 'md-home',
        },
        component: () => import('@/views/home/index'),
      },
      {
        path: '/workbench',
        name: 'workbench',
        meta: {
          title: '工作台',
          icon: 'md-home',
        },
        component: () => import('@/views/workbench/index'),
      },
      {
        path: '/trace',
        name: 'trace',
        meta: {
          title: '溯源信息(旧版)',
          icon: 'md-home',
        },
        component: () => import('@/views/trace'),
      },
      {
        path: '/system/account',
        name: 'account',
        meta: {
          title: '账号管理',
          icon: 'md-home',
        },
        component: () => import('@/views/system/account'),
      },
      {
        path: '/system/role',
        name: 'role',
        meta: {
          title: '角色管理',
          icon: 'md-home',
        },
        component: () => import('@/views/system/role'),
      },
      {
        path: '/system/log',
        name: 'log',
        meta: {
          title: '系统操作日志',
          icon: 'md-home',
        },
        component: () => import('@/views/system/log'),
      },
      {
        path: '/srm/data/enterprise',
        name: 'role',
        meta: {
          title: '企业信息',
          icon: 'md-home',
        },
        component: () => import('@/views/data/enterprise'),
      },
      {
        path: '/srm/data/baseTemplate',
        name: 'baseTemplage',
        meta: {
          title: '基地模版',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/data/baseTemplate'),
      },
      {
        path: '/srm/data/baseTemplate/create',
        name: 'baseTemplateCreate',
        meta: {
          title: '基地模版新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/baseTemplate/modify'),
      },
      {
        path: '/srm/data/baseTemplate/edit',
        name: 'baseTemplateEdit',
        meta: {
          title: '基地模版编辑',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/baseTemplate/modify'),
      },
      {
        path: '/srm/data/baseTemplate/detail',
        name: 'baseTemplateDetail',
        meta: {
          title: '基地模版详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/baseTemplate/modify'),
      },
      {
        path: '/srm/data/rawMaterial',
        name: 'rawMaterial',
        meta: {
          title: '原料模版',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/data/rawMaterial'),
      },
      {
        path: '/srm/data/rawMaterial/create',
        name: 'rawMaterialCreate',
        meta: {
          title: '原料模版新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/rawMaterial/modify'),
      },
      {
        path: '/srm/data/rawMaterial/edit',
        name: 'rawMaterialEdit',
        meta: {
          title: '原料模版编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/data/rawMaterial/modify'),
      },
      {
        path: '/srm/data/rawMaterial/detail',
        name: 'rawMaterialDetail',
        meta: {
          title: '原料模版详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/rawMaterial/modify'),
      },
      {
        path: '/srm/data/semiFinishedProduct',
        name: 'semiFinishedProduct',
        meta: {
          title: '半成品模版',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/data/semiFinishedProduct'),
      },
      {
        path: '/srm/data/semiFinishedProduct/create',
        name: 'semiFinishedProductCreate',
        meta: {
          title: '半成品新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/semiFinishedProduct/modify'),
      },
      {
        path: '/srm/data/semiFinishedProduct/edit',
        name: 'semiFinishedProductEdit',
        meta: {
          title: '半成品编辑',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/semiFinishedProduct/modify'),
      },
      {
        path: '/srm/data/semiFinishedProduct/detail',
        name: 'semiFinishedProductDetail',
        meta: {
          title: '半成品详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/semiFinishedProduct/modify'),
      },
      {
        path: '/srm/data/finishProduct',
        name: 'finishProduct',
        meta: {
          title: '成品模版',
          icon: 'md-home',
          keepAlive: true,
          auth: false,
        },
        component: () => import('@/views/data/finishProduct'),
      },
      {
        path: '/srm/data/finishProduct/create',
        name: 'finishProductCreate',
        meta: {
          title: '成品模版新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/finishProduct/modify'),
      },
      {
        path: '/srm/data/finishProduct/edit',
        name: 'finishProductEdit',
        meta: {
          title: '成品模版编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/data/finishProduct/modify'),
      },
      {
        path: '/srm/data/finishProduct/detail',
        name: 'finishProductDetail',
        meta: {
          title: '成品模版详情',
          icon: 'md-home',
        },
        component: () => import('@/views/data/finishProduct/modify'),
      },
      {
        path: '/srm/data/goodsBarcode',
        name: 'goodsBarcode',
        meta: {
          title: '商品条码',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/data/goodsBarcode'),
      },
      {
        path: '/srm/data/goodsBarcode/create',
        name: 'goodsBarcodeCreate',
        meta: {
          title: '条码模版新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/goodsBarcode/modify'),
      },
      {
        path: '/srm/data/goodsBarcode/edit',
        name: 'goodsBarcodeEdit',
        meta: {
          title: '条码模版编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/data/goodsBarcode/modify'),
      },
      {
        path: '/srm/data/goodsBarcode/detail',
        name: 'goodsBarcodeDetail',
        meta: {
          title: '条码模版详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/data/goodsBarcode/modify'),
      },
      {
        path: '/srm/traceLink/purchase',
        name: 'purchase',
        meta: {
          title: '原料采购管理',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/purchase'),
      },
      {
        path: '/srm/traceLink/purchase/create',
        name: 'purchaseCreate',
        meta: {
          title: '原料采购新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/traceLink/purchase/modify'),
      },
      {
        path: '/srm/traceLink/purchase/edit',
        name: 'purchaseEdit',
        meta: {
          title: '原料采购编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/traceLink/purchase/modify'),
      },
      {
        path: '/srm/traceLink/purchase/detail',
        name: 'purchaseDetail',
        meta: {
          title: '原料采购详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/traceLink/purchase/modify'),
      },
      {
        path: '/srm/traceLink/quality',
        name: 'quality',
        meta: {
          title: '原料质检管理',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/quality'),
      },
      {
        path: '/srm/traceLink/quality/create',
        name: 'qualityCreate',
        meta: {
          title: '原料质检新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/traceLink/quality/modify'),
      },
      {
        path: '/srm/traceLink/quality/edit',
        name: 'qualityEdit',
        meta: {
          title: '原料质检编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/traceLink/quality/modify'),
      },
      {
        path: '/srm/traceLink/quality/detail',
        name: 'qualityDetail',
        meta: {
          title: '原料质检详情',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/traceLink/quality/modify'),
      },
      {
        path: '/srm/traceLink/warehousing',
        name: 'warehousing',
        meta: {
          title: '原料入库管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/warehousing'),
      },
      {
        path: '/srm/traceLink/warehousing/create',
        name: 'warehousingCreate',
        meta: {
          title: '原料入库新增',
        },
        component: () => import('@/views/traceLink/warehousing/modify'),
      },
      {
        path: '/srm/traceLink/warehousing/edit',
        name: 'warehousingEdit',
        meta: {
          title: '原料入库编辑',
        },
        component: () => import('@/views/traceLink/warehousing/modify'),
      },
      {
        path: '/srm/traceLink/warehousing/detail',
        name: 'warehousingDetail',
        meta: {
          title: '原料入库详情',
        },
        component: () => import('@/views/traceLink/warehousing/modify'),
      },
      {
        path: '/srm/traceLink/warehouseEx',
        name: 'warehouseEx',
        meta: {
          title: '原料出库管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/warehouseEx'),
      },
      {
        path: '/srm/traceLink/warehouseEx/create',
        name: 'warehouseExCreate',
        meta: {
          title: '原料出库新增',
        },
        component: () => import('@/views/traceLink/warehouseEx/modify'),
      },
      {
        path: '/srm/traceLink/warehouseEx/edit',
        name: 'warehouseExEdit',
        meta: {
          title: '原料出库编辑',
        },
        component: () => import('@/views/traceLink/warehouseEx/modify'),
      },
      {
        path: '/srm/traceLink/warehouseEx/detail',
        name: 'warehouseExDetail',
        meta: {
          title: '原料出库详情',
        },
        component: () => import('@/views/traceLink/warehouseEx/modify'),
      },
      {
        path: '/srm/traceLink/produce',
        name: 'produce',
        meta: {
          title: '饮片生产管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/produce'),
      },
      {
        path: '/srm/traceLink/produce/create',
        name: 'produceCreate',
        meta: {
          title: '饮片生产新增',
        },
        component: () => import('@/views/traceLink/produce/modify'),
      },
      {
        path: '/srm/traceLink/produce/edit',
        name: 'produceEdit',
        meta: {
          title: '饮片生产编辑',
        },
        component: () => import('@/views/traceLink/produce/modify'),
      },
      {
        path: '/srm/traceLink/produce/detail',
        name: 'produceDetail',
        meta: {
          title: '饮片生产详情',
        },
        component: () => import('@/views/traceLink/produce/modify'),
      },
      {
        path: '/srm/traceLink/inspection',
        name: 'inspection',
        meta: {
          title: '饮片质检管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/inspection'),
      },
      {
        path: '/srm/traceLink/inspection/create',
        name: 'inspectionCreate',
        meta: {
          title: '饮片质检新增',
        },
        component: () => import('@/views/traceLink/inspection/modify'),
      },
      {
        path: '/srm/traceLink/inspection/edit',
        name: 'inspectionEdit',
        meta: {
          title: '饮片质检编辑',
        },
        component: () => import('@/views/traceLink/inspection/modify'),
      },
      {
        path: '/srm/traceLink/inspection/detail',
        name: 'inspectionDetail',
        meta: {
          title: '饮片质检详情',
        },
        component: () => import('@/views/traceLink/inspection/modify'),
      },
      {
        path: '/srm/traceLink/package',
        name: 'package',
        meta: {
          title: '饮片包装管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/package'),
      },
      {
        path: '/srm/traceLink/package/create',
        name: 'packageCreate',
        meta: {
          title: '饮片包装新增',
        },
        component: () => import('@/views/traceLink/package/modify'),
      },
      {
        path: '/srm/traceLink/package/edit',
        name: 'packageEdit',
        meta: {
          title: '饮片包装编辑',
        },
        component: () => import('@/views/traceLink/package/modify'),
      },
      {
        path: '/srm/traceLink/package/detail',
        name: 'packageDetail',
        meta: {
          title: '饮片包装详情',
        },
        component: () => import('@/views/traceLink/package/modify'),
      },
      {
        path: '/srm/traceLink/finishedProductQuality',
        name: 'finishedProductQuality',
        meta: {
          title: '饮片质检管理',
          keepAlive: true,
        },
        component: () => import('@/views/traceLink/finishedProductQuality'),
      },
      {
        path: '/srm/traceLink/finishedProductQuality/create',
        name: 'finishedProductQualityCreate',
        meta: {
          title: '饮片质检新增',
        },
        component: () => import('@/views/traceLink/finishedProductQuality/modify'),
      },
      {
        path: '/srm/traceLink/finishedProductQuality/edit',
        name: 'finishedProductQualityEdit',
        meta: {
          title: '饮片质检编辑',
        },
        component: () => import('@/views/traceLink/finishedProductQuality/modify'),
      },
      {
        path: '/srm/traceLink/finishedProductQuality/detail',
        name: 'finishedProductQualityDetail',
        meta: {
          title: '饮片质检详情',
        },
        component: () => import('@/views/traceLink/finishedProductQuality/modify'),
      },
      {
        path: '/srm/traceCode/information',
        name: 'information',
        meta: {
          title: '饮片赋码',
          keepAlive: true,
        },
        component: () => import('@/views/traceCode/information'),
      },
      {
        path: '/srm/traceCode/information/create',
        name: 'informationCreate',
        meta: {
          title: '饮片赋码新增',
          icon: 'md-home',
          keepAlive: true,
        },
        component: () => import('@/views/traceCode/information/modify'),
      },
      {
        path: '/srm/traceCode/information/edit',
        name: 'informationEdit',
        meta: {
          title: '饮片赋码编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/traceCode/information/modify'),
      },
      {
        path: '/srm/traceCode/information/detail',
        name: 'informationDetail',
        meta: {
          title: '饮片赋码详情',
          icon: 'md-home',
        },
        component: () => import('@/views/traceCode/information/modify'),
      },
      {
        path: '/srm/traceCode/medicinalCode',
        name: 'medicinalCode',
        meta: {
          title: '药材赋码',
          keepAlive: true,
        },
        component: () => import('@/views/traceCode/medicinalCode/index.vue'),
      },
      {
        path: '/srm/traceCode/medicinalCode/create',
        name: 'medicinalCodeCreate',
        meta: {
          title: '药材赋码新增',
          icon: 'md-home',
          auth: false,
        },
        component: () => import('@/views/traceCode/medicinalCode/modify.vue'),
      },
      {
        path: '/srm/traceCode/medicinalCode/edit',
        name: 'medicinalCodeEdit',
        meta: {
          title: '药材赋码编辑',
          icon: 'md-home',
          keepAlive: false,
          auth: false,
        },
        component: () => import('@/views/traceCode/medicinalCode/modify.vue'),
      },
      {
        path: '/srm/traceCode/medicinalCode/detail',
        name: 'medicinalCodeDetail',
        meta: {
          title: '药材赋码详情',
          icon: 'md-home',
        },
        component: () => import('@/views/traceCode/medicinalCode/modify.vue'),
      },
      {
        path: '/downloadCenter',
        name: 'downloadCenter',
        meta: {
          title: '下载中心',
          icon: 'md-home',
        },
        component: () => import('@/views/system/downloadCenter'),
      },
      {
        path: '/helpCenter',
        name: 'helpCenter',
        meta: {
          title: '帮助中心',
          icon: 'md-home',
        },
        component: () => import('@/views/system/helpCenter'),
      },
      {
        path: '/updateLog',
        name: 'updateLog',
        meta: {
          title: '更新日志',
          icon: 'md-home',
        },
        component: () => import('@/views/system/updateLog'),
      },
      {
        path: '/srm/medicinalManage/medicinalTrace',
        name: 'medicinalTrace',
        meta: {
          title: '药材追溯',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/medicinalManage/medicinalTrace'),
      },
      {
        path: '/srm/medicinalManage/medicinalTrace/create',
        name: 'medicinalTraceCreate',
        meta: {
          title: '药材追溯新增',
          icon: 'md-home',
        },
        component: () => import('@/views/medicinalManage/medicinalTrace/modify'),
      },
      {
        path: '/srm/medicinalManage/medicinalTrace/edit',
        name: 'medicinalTraceEdit',
        meta: {
          title: '药材追溯编辑',
          icon: 'md-home',
        },
        component: () => import('@/views/medicinalManage/medicinalTrace/modify'),
      },
      {
        path: '/srm/medicinalManage/medicinalTrace/detail',
        name: 'medicinalTraceDetail',
        meta: {
          title: '药材追溯详情',
          icon: 'md-home',
        },
        component: () => import('@/views/medicinalManage/medicinalTrace/modify'),
      },
      {
        path: '/srm/backStageManage/configCenter',
        name: 'configCenter',
        meta: {
          title: '配置中心',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/configCenter/index'),
      },
      {
        path: '/srm/backStageManage/companyManage',
        name: 'companyManage',
        meta: {
          title: '企业管理',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/companyManage/index'),
      },
      {
        path: '/srm/backStageManage/versionManage',
        name: 'versionManage',
        meta: {
          title: '版本管理',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/versionManage/index'),
      },
      {
        path: '/srm/backStageManage/dataManage',
        name: 'dataManage',
        group: 'dataManage',
        meta: {
          title: '基础数据管理',
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/dataManage/index'),
      },
      {
        path: '/srm/backStageManage/updateLogManage',
        name: 'updateLogManage',
        meta: {
          title: '更新日志管理',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/updateLogManage/index'),
      },
      {
        path: '/srm/backStageManage/helpCenterManage',
        name: 'helpCenterManage',
        meta: {
          title: '帮助中心管理',
          keepAlive: true,
          icon: 'md-home',
        },
        component: () => import('@/views/backStageManage/helpCenterManage/index'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      hideInMenu: true,
    },
    component: () => import('@/views/auth/login'),
  },
  {
    path: '/qrCode',
    name: 'qrCode',
    meta: {
      title: '中药饮片产业链追溯平台',
      hideInMenu: true,
      auth: false,
    },
    component: () => import('@/views/qrcode/index'),
  },
  {
    path: '/traceDetail',
    name: 'traceDetail',
    meta: {
      title: '中药饮片产业链追溯平台',
      hideInMenu: true,
      auth: false,
    },
    component: () => import('@/views/traceDetail/traceDetail'),
  },
  { path: '*', redirect: '/home' },
]
